module.exports = __webpack_public_path__ + "img/Marketing-rafiki.fb530488.svg";